/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'button/back': {
    width: 23,
    height: 23,
    viewBox: '0 0 23 23',
    data: '<path pid="0" d="M5.033 13.1a.5.5 0 000 .8L9.7 17.4a.5.5 0 00.8-.4v-7a.5.5 0 00-.8-.4l-4.667 3.5z" _fill="currentColor"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M11.5 5.75h4.25a1 1 0 011 1v6.5a1 1 0 01-1 1H8.5v-1.5h6.25a.5.5 0 00.5-.5v-4.5a.5.5 0 00-.5-.5H11.5v-1.5z" _fill="currentColor"/>'
  }
})
